/**
 * Avatar Upload API
 *
 * Posts a cropped, resized JPEG (base64 data URL) to the main-server, which
 * pushes it to Bunny CDN and returns the cache-busted public picture URL.
 * Mirrors the UDG Poker flow: client crops/encodes, server stores + serves.
 */

import { serverConfig } from '../network/ServerConfig';

export interface AvatarUploadResult {
  picture: string;
}

/**
 * Upload a JPEG data URL as the authenticated player's avatar.
 * @param imageDataUrl `data:image/jpeg;base64,...`
 * @param token        JWT issued in the auth:success payload
 */
export async function uploadAvatar(imageDataUrl: string, token: string): Promise<AvatarUploadResult> {
  const resp = await fetch(`${serverConfig.mainServerUrl}/api/player/avatar`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ image: imageDataUrl }),
  });

  if (!resp.ok) {
    let message = `Upload failed (${resp.status})`;
    try {
      const body = await resp.json();
      if (body?.error) message = body.error;
    } catch {
      // non-JSON error body — keep the status message
    }
    throw new Error(message);
  }

  return resp.json() as Promise<AvatarUploadResult>;
}
